import {Component, HostListener, OnInit} from '@angular/core';
import {SharedResource} from "../../../model/shared-resource";
import {SharedFilters} from "../../../model/filters/shared-filters";
import {Tenant} from "../../../model/tenant";
import {Organization} from "../../../model/organization";
import {User} from "../../../model/user";
import {SharedService} from "../../../services/shared.service";
import {OrganizationsService} from "../../../services/organizations.service";
import {TenantsService} from "../../../services/tenants.service";
import {AuthGuard} from "../../../common/auth-guard.service";
import {FiltersService} from "../../../services/filters.service";

@Component({
  selector: 'app-shared-by-user',
  templateUrl: './shared-by-user.component.html',
  styleUrls: ['./shared-by-user.component.scss']
})
export class SharedByUserComponent implements OnInit {

  public sharedResources: SharedResource[];
  public totalResources: number;
  public loadingSharedResources: boolean;

  public rows = 10;
  public first = 0;
  public blobs = {};

  public filtersVisible: boolean;
  public currentFilters: SharedFilters;
  public filtersFilled: boolean;
  public loadingFilters: boolean;

  public tenants: Tenant[];
  public organizations: Organization[];

  constructor(private sharedService: SharedService,
              private organizationsService: OrganizationsService,
              private tenantsService: TenantsService,
              public authGuardService: AuthGuard,
              private filtersService: FiltersService<SharedFilters>) {
    this.currentFilters = new SharedFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.loadFilters().then(() => {
      Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    });
    this.sharedResources = new Array(this.rows);
  }

  private loadSharedResources(offset?: number, limit?: number): void {
    this.loadingSharedResources = true;
    this.sharedResources = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.sharedService.getSharedResourcesByUser(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters : this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        response.applicationBlobs.forEach(appBlob => this.blobs[appBlob.applicationCode] = `data:image/png;base64,${appBlob.base64Blob}`);
        this.sharedResources = response.sharedResources;
        this.totalResources = response.totalElements;
        this.loadingSharedResources = false;
      });
  }

  onPageChange(event): void {
    this.loadSharedResources(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new SharedFilters();
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true) {
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadSharedResources(this.first / this.rows, this.rows);
  }

  trimFieldsForm(filters: SharedFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  private loadFilters(): Promise<any> {
    this.loadingFilters = true;
    let promises: Array<Promise<any>> = [this.organizationsService.getOrganizations().toPromise()];
    if (this.authGuardService.superAdminRequired()) {
      promises.push(this.tenantsService.getTenants().toPromise());
    }
    return Promise.all(promises).then(response => {
      this.organizations = response[0].organizations.sort((a, b) => a.name > b.name ? 1 : -1);
      if (this.authGuardService.superAdminRequired()) {
        this.tenants = response[1].tenants.sort((a, b) => a.name > b.name ? 1 : -1);
      }
      this.loadingFilters = false;
    });
  }

  setSelectedResourceType(type: string): void {
    this.currentFilters.resourceType = type;
  }

  get filteredOrganizations(): Organization[] {
    if (this.authGuardService.superAdminRequired()) {
      if (this.currentFilters.tenantUuids?.length > 0) {
        return this.organizations.filter(org => this.currentFilters.tenantUuids.includes(org.tenant.uuid));
      }
    }
    return this.organizations;
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
